export default async function getNumberJuzuReads() {
  const response = await fetch('https://api.idrissa-sall.com/kamil/numberOfReads/juzu');
  const data = await response.json();
  
  return data.numberOfReads;
}